import { PRICING_PATH } from "@/modules/plan/copy";

export const PUBLIC_CONTAINER = "mx-auto w-full max-w-6xl px-4 md:px-6";

export interface PublicNavItem {
  href: string;
  label: string;
}

// 주 메뉴 한 칸 — section(첫 화면 구간 앵커)·page(따로 있는 화면) 중 하나는 꼭 있다.
type MenuItem = { label: string } & ({ section: string; page?: string } | { section?: undefined; page: string });

const MENU: readonly MenuItem[] = [
  { label: "기능", section: "flow" },
  { label: "요금제", section: "pricing", page: PRICING_PATH },
  { label: "무료 도구", page: "/tools" },
  { label: "자주 묻는 질문", section: "faq" },
];

// 첫 화면 안이면 구간 앵커를, 밖이면 화면 주소(없으면 첫 화면 앵커)를 쓴다.
const hrefOf = (item: MenuItem, onLanding: boolean): string => {
  if (item.section === undefined) return item.page;
  return onLanding ? `#${item.section}` : (item.page ?? `/#${item.section}`);
};

const menuFor = (onLanding: boolean): readonly PublicNavItem[] => MENU.map((item) => ({ label: item.label, href: hrefOf(item, onLanding) }));

export const PUBLIC_NAV = menuFor(false);
export const LANDING_NAV = menuFor(true);
